import { Box, Grid, Tab } from "@material-ui/core";
import { TabContext, TabList } from "@material-ui/lab";

const CountersTabs = ({ counterTab, changeTab }) => {
  return (
    <>
      <Box
        sx={{
          width: "100%",
          typography: "body1",
          background: "white",
        }}
        style={{
          boxShadow: "0 1px 1px 0 #999",
          borderRadius: "5px",
        }}
      >
        <TabContext value={counterTab.value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Grid container xs={12} sm={12} md={12} lg={12}>
              <TabList
                onChange={changeTab}
                variant="scrollable"
                scrollButtons="auto"
                textColor="secondary"
                indicatorColor="secondary"
              >
                <Tab iconPosition="start" label="آب" value="0" />
                <Tab iconPosition="start" label="برق" value="1" />
                <Tab iconPosition="start" label="گاز" value="2" />
              </TabList>
            </Grid>
          </Box>
        </TabContext>
      </Box>
    </>
  );
};
export default CountersTabs;
